import lowercaseFormatDuration from 'owa-duration-formatter/lib/lowercase';
var SECONDS_IN_MINUTE = 60;
var eventOptions = [
    { key: 15, text: '' },
    { key: 25, text: '' },
    { key: 30, text: '' },
    { key: 45, text: '' },
    { key: 55, text: '' },
    { key: 60, text: '' },
];
/* Check if the selected duration exists in the dropdown.
 * If not present, then add the custom event duration.
 * This can happen when a user chooses the custom option in event duration settings (JSMVVM) and moves to React.
 */
export default function createEventDurationDropdownOptions(selectedDuration) {
    var eventDropdownOptions = [];
    eventOptions.forEach(function (option) {
        var newOption = {
            key: option.key,
            text: lowercaseFormatDuration(option.key * SECONDS_IN_MINUTE),
        };
        eventDropdownOptions.push(newOption);
    });
    if (!isSelectedDurationPresent(eventDropdownOptions, selectedDuration)) {
        eventDropdownOptions.push({
            key: selectedDuration,
            text: lowercaseFormatDuration(selectedDuration * SECONDS_IN_MINUTE),
        });
        eventDropdownOptions.sort(function (a, b) { return a.key - b.key; });
    }
    return eventDropdownOptions;
}
function isSelectedDurationPresent(eventDropdownOptions, selectedDuration) {
    var selectedOptionPresent = false;
    for (var i = 0; i < eventDropdownOptions.length; i++) {
        if (eventDropdownOptions[i].key == selectedDuration) {
            selectedOptionPresent = true;
            break;
        }
    }
    return selectedOptionPresent;
}
//# sourceMappingURL=createEventDurationDropdownOptions.js.map